import axios from "axios";
export default {
    deleteSummaryReport: (summaryReportId) => axios.post("/SummaryReports/DeleteSummaryReport", { Id: summaryReportId })
};
